import React, { useRef } from 'react';
import { Heading, Icon, Loader, ModalBox, useMediaQueryContext, useModalContext, } from '@fourthwall/components';
import { ArrowShortLeftIcon } from '@fourthwall/icons';
import { SectionItem } from '../SectionItemV2';
import { IFramePreview } from './components/IFramePreview/IFramePreview';
import * as S from './styled';
export const AddSectionModalView = ({ blockId, sections, selectedSection, onCreateLayoutSection, filterSections, onSectionSelect, }) => {
    const { close } = useModalContext();
    const media = useMediaQueryContext();
    const containerRef = useRef(null);
    const renderSectionItems = (sections) => (React.createElement(React.Fragment, null, sections
        .filter((s) => !filterSections.includes(s.sectionType))
        .map((item) => (React.createElement(SectionItem, { key: item.sectionType, section: item, active: selectedSection === item, onClick: () => {
            onSectionSelect(item);
        } })))));
    // window.addEventListener(
    //   'messag2e',
    //   (e) => {
    //     if (e.data.action === 'test' && containerRef.current) {
    //       setIframeStyles({
    //         // @ts-ignore
    //         '--containerHeight': `${containerRef.current.offsetHeight}`,
    //         '--containerWidth': `${containerRef.current.offsetWidth}`,
    //         '--previewHeight': `${e.data.data.height}`,
    //         '--previewWidth': `${e.data.data.width}`,
    //       })
    //       setIframeLoaded(true)
    //     }
    //   },
    //   false,
    // )
    const renderPreview = (section) => {
        return (React.createElement(React.Fragment, null, section.presets.map((preset) => (React.createElement(S.PreviewButton, { style: { width: '100%', height: '100%', padding: '4px' }, type: "button", key: preset.name, onClick: () => onCreateLayoutSection(section.sectionType, blockId, section.platformAppId, preset.name) },
            React.createElement(IFramePreview, { url: preset.previewUrl }))))));
    };
    const renderContent = () => {
        if (!sections)
            return null;
        if (media.tablet) {
            return (React.createElement(S.Content, null,
                React.createElement(S.Sidebar, null,
                    React.createElement(S.TitleContainer, null,
                        React.createElement(Heading, { type: "h3", weight: "semibold" }, "Add new section")),
                    sections.length === 1 && (React.createElement(React.Fragment, null, sections.map(({ group, sections }) => (React.createElement("div", { key: group }, renderSectionItems(sections)))))),
                    sections.length > 1 && (React.createElement(React.Fragment, null, sections.map(({ group, sections }) => (React.createElement(S.SectionWrapper, { key: group },
                        React.createElement(S.SectionHeader, null, group),
                        React.createElement(S.SectionContent, null, renderSectionItems(sections)))))))),
                selectedSection && React.createElement(S.Previews, null, renderPreview(selectedSection))));
        }
        if (selectedSection) {
            return (React.createElement(S.Sidebar, null,
                React.createElement("button", { type: "button", onClick: () => onSectionSelect(null) },
                    React.createElement(S.TitleContainer, null,
                        React.createElement(Icon, { component: ArrowShortLeftIcon, height: 16 }),
                        React.createElement(Heading, { type: "h3", weight: "semibold" }, selectedSection.name))),
                React.createElement(S.Previews, { ref: containerRef }, renderPreview(selectedSection))));
        }
        return (React.createElement(S.Sidebar, null,
            React.createElement(S.TitleContainer, null,
                React.createElement(Heading, { type: "h3", weight: "semibold" }, "Add new section")),
            sections.length === 1 && (React.createElement(React.Fragment, null, sections.map(({ group, sections }) => (React.createElement("div", { key: group }, renderSectionItems(sections)))))),
            sections.length > 1 && (React.createElement(React.Fragment, null, sections.map(({ group, sections }) => (React.createElement(S.SectionWrapper, { key: group },
                React.createElement(S.SectionHeader, null, group),
                React.createElement(S.SectionContent, null, renderSectionItems(sections)))))))));
    };
    const renderLoader = () => {
        if (sections)
            return null;
        return (React.createElement(S.LoaderWrapper, null,
            React.createElement(Loader, { size: "large" })));
    };
    return (React.createElement(ModalBox, { maxWidth: 1110, disableScrolling: true, withoutPadding: true, onClose: close },
        renderLoader(),
        renderContent()));
};
